export default __webpack_public_path__ + "./images/mh.428125b0.png";